'use strict';exports.__esModule = true;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};var stringifySelect = function stringifySelect(array) {
  if (array.constructor !== Array) {
    throw new Error('Expected Array as an input, got ' + (typeof array === 'undefined' ? 'undefined' : _typeof(array)));
  }

  var first = null;
  var current = false;
  var previous = false;
  var moreThanTwo = false;
  var result = '';

  for (var idx = 0; idx < array.length; idx += 1) {
    current = array[idx + 1] - array[idx] === 1;

    if (!current && !previous) {
      result += array[idx] + ', ';
    } else if (current && !previous) {
      first = array[idx];
    } else if (current && previous) {
      moreThanTwo = true;
    } else if (!current && previous) {
      if (moreThanTwo) {
        result += first + '-' + array[idx] + ', ';
        first = null;
        moreThanTwo = false;
      } else {
        result += first + ', ' + array[idx] + ', ';
      }
    }

    previous = current;
  }

  return result.slice(0, result.length - 2).replace(/\s/g, ' ');
};exports.default =

stringifySelect;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/stringifySelect.js
// module id = 601
// module chunks = 0